module.exports = __webpack_public_path__ + "img/pbms-mobile.2b003618.jpg";